import * as actionTypes from '../Actions/actionTypes';

const defaultState = {
	apiFlag: true,
	Data: [],
	select: [],
	selectHandler: []
};

export default function setCanteenItemsReducer(
	state = defaultState,
	action = {}
) {
	switch (action.type) {
		case actionTypes.SET_ALL_HANDLER_NAME_INTO_CANTEEN_SELECT:
			return {
				...state,
				selectHandler: [...action.payload]
			};
		case actionTypes.SET_ALL_CAMPUS_NAME_INTO_CANTEEN_SELECT:
			return {
				...state,
				select: [...action.payload]
			};

		case actionTypes.SET_ALL_CATEGORY_NAME_INTO_ITEMS_SELECT:
			return {
				...state,
				select: [...action.payload]
			};
		case actionTypes.GET_ALL_CANTEEN_ITEMS:
			return {
				...state,
				Data: [...action.payload]
			};
		case actionTypes.SET_LOADER_FLAG_CANTEEN_ITEMS:
			return {
				...state,
				apiFlag: action.payload
			};
		case actionTypes.DELETE_CANTEEN_ITEMS:
			let filterCandidateReqList = state.Data.filter(
				filterOBJ => filterOBJ.id !== action.payload
			);

			return {
				...state,
				Data: filterCandidateReqList
			};
		case actionTypes.EDIT_CANTEEN_ITEMS_RECORD:
			var adminData = [...state.Data];
			var index = adminData.findIndex(obj => obj.t2.id === action.payload.id);

			adminData[index].t2.name = action.payload.name;
			adminData[index].t2.stock = action.payload.stock;
			adminData[index].t2.price = action.payload.price;
			adminData[index].Category = action.payload.categoryName;
			return {
				...state,
				Data: [...adminData]
			};
		default:
			return state;
	}
}
